import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getPcrIdSelector } from '../../../home/selectors'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { IPcr } from '../../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../../user/selectors'
import { getPnMedicationSelector } from '../selectors/pnMedication.selector'
import { setAddToTimeLine, setResponse } from '../store/pnMedication.actions'
import { IPnMedicationState } from '../store/pnMedication.types'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { PnMedicationConstants } from '../store/pnMedication.constants'
import { addPnMedicationItem } from '../../../timeline/store/timeline.actions'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'
import { cloneDeep } from 'lodash'

export function* savePnMedication() {
  const pnMedicationState: IPnMedicationState = yield select(getPnMedicationSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrID: string = yield select(getPcrIdSelector)
  const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
  const pcrDocUpdated = cloneDeep(pcrDoc)

  if (!pcrID) {
    // todo: add to audit log
    return
  }
  const { addMedicationAdministeredData } = pnMedicationState
  const newPnMedicationData =
    addMedicationAdministeredData?.filter(
      (medication) =>
        medication?.medicationPNNV !== null ||
        medication?.dose !== null ||
        medication?.doseUnit !== null ||
        medication?.medication !== null ||
        medication?.route !== null
    ) || []
  const medList = pcrDocUpdated.patient?.medicationAdministeredStateListPNNVs ?? []
  const index = medList.findIndex((mas) => mas.key === pnMedicationState.key)
  const updatedMedication = {
    ...pnMedicationState,
    addMedicationAdministeredData: newPnMedicationData,
  }

  if (medList && medList.length) {
    if (index !== -1) {
      medList[index] = updatedMedication
    } else {
      medList.push(updatedMedication)
    }
  } else {
    pcrDocUpdated.patient = {
      ...pcrDocUpdated.patient,
      medicationAdministeredStateListPNNVs: [updatedMedication],
    }
  }
  try {
    const response: string = yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
    yield put(setAddToTimeLine(true))
    yield put(setResponse(response))
    yield put(addPnMedicationItem())
  } catch (e) {
    yield put(throwPcrException(`PnMedication() error: ${e}`))
  }
}

export function* savePnMedicationSaga() {
  yield takeLatest(
    [
      PnMedicationConstants.SAVE_PN_MEDICATION,
      PnMedicationConstants.SET_DATE,
      PnMedicationConstants.SET_TIME,
      PnMedicationConstants.SET_DATE_TIME,
      PnMedicationConstants.SET_PTA,
    ],
    performWithMutexHOG,
    savePnMedication
  )
}
